/************************************************************************
** IBM Confidential
**
** IBM Business Analytics: Rapidly Adaptive Visualization Engine
**
** (C) Copyright IBM Corp. 2017
**
** The source code for this program is not published or otherwise divested of its trade secrets, 
** irrespective of what has been deposited with the U.S. Copyright Office.
************************************************************************/
export default class NativeImpl {
	static invokeMethodByReflection(clazz, methodName, obj, paramObj1, paramObj2) {
		var result = null;
		if (methodName === "value") {
			result = obj.value();
		} else if (methodName === "fromValue") {
			result = clazz.fromValue(paramObj1);
		} else if (methodName === "fromJSON") {
			result = clazz.fromJSON(paramObj1, paramObj2);
		}
		return result;
	}
}


// WEBPACK FOOTER //
// ./src/generated/NativeImpl.js